import React from 'react'
import { Link,NavLink } from 'react-router-dom'
import useTheme from './hooks/useTheme'
import './Recipelist.css'
import DeleteIcon from '../components/assets/dlt.svg'
import Editicon from '../components/assets/edit.svg'

import { projFirestore } from './firebase/config'

export default function RecipeList({recipes}) {
const {mode} = useTheme()
if (recipes.length===0){
    return (
        <div className='error'><h3>No results found</h3></div>
    )
}
const handleClick = (id) =>{
    projFirestore.collection('recipes').doc(id).delete()
}
  return (
    <div className='recipe-list'>
        {recipes.map((recipe)=>(
            <div key={recipe.id} className={`card ${mode}`}>
                <h3>{recipe.title}</h3>
                <p>{recipe.cookingTime} to make</p>
                <div>{recipe.method.substring(0,100)}...</div>
                <Link className='link' to={`/recipes/${recipe.id}`}>Cook this</Link>
                <img className='delete' alt='delete icon'
                src={DeleteIcon}
                onClick={()=>handleClick(recipe.id)} />
                <NavLink to={`/edit/${recipe.id}`}>
                <img className='edit' alt='edit icon'
                src={Editicon}
                 />
                </NavLink> 
            </div>
        ))}
    </div>
  )
}
